import { useMutation, UseMutationOptions } from '@tanstack/react-query';
import axiosInstance from 'axiosConfig';
import { Toast } from 'components';
import { TOAST_TYPES_ENUM } from 'enums';

interface UpdateAdditionalVisitDetailsType {
  uuid: string | null;
  date: string;
  start: string;
  end: string;
  comment: string;
  employeeUuid: string;
  checkList: { item: string }[];
}

const useUpdateAdditionalVisit = (
  options?: UseMutationOptions<any, Error, UpdateAdditionalVisitDetailsType>
) => {
  return useMutation({
    ...options,
    mutationKey: ['updateAdditionalVisit'],
    mutationFn: async ({ uuid, date, start, end, comment, employeeUuid, checkList }) => {
      return axiosInstance.put(`/orders/additional-visit/determine/${uuid}`, {
        date,
        start,
        end,
        comment,
        employeeUuid,
        checkList,
      }).then((res) => res.data);
    },
    onMutate: (variables) => {
      Toast({
        message: 'Przetwarzanie aktualizacji wizyty...',
        type: TOAST_TYPES_ENUM.LOADING,
        id: 'update-additional-visit',
      });
      if (options && options.onMutate) {
        return options.onMutate(variables);
      }
    },
    onSuccess: (data, variables, context) => {
      Toast({
        message: 'Wizyta została pomyślnie zaktualizowana',
        type: TOAST_TYPES_ENUM.SUCCESS,
        id: 'update-additional-visit',
      });
      if (options && options.onSuccess) {
        options.onSuccess(data, variables, context);
      }
    },
    onError: (error, variables, context) => {
      Toast({
        message: 'Błąd podczas aktualizacji wizyty',
        type: TOAST_TYPES_ENUM.ERROR,
        id: 'update-additional-visit',
      });
      if (options && options.onError) {
        options.onError(error, variables, context);
      }
    },
  });
};

export default useUpdateAdditionalVisit;
